/**
 * main.jsx — Application entry point
 *
 * Wraps the entire app in:
 * 1. React.StrictMode — catches common mistakes in development
 * 2. BrowserRouter — enables URL-based routing
 * 3. QueryClientProvider — TanStack Query for all server state
 * 4. AuthProvider — auth state and actions
 * 5. ToastProvider — toast notification system
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { queryClient } from './lib/queryClient';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './components/layout/Toast';
import theme from './theme';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
